<template>
	<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
		<div class="widget-location">
			<h3>노데이타</h3>
		</div>
		<div class="list-top">
			<div class="page-info">
				<span>전체 : <strong>{{total}}</strong> ( {{current_page}} / {{last_page}} 페이지 )</span>
			</div>
		</div>

		<el-table
		  :data="tableData" empty-text="데이터가 없습니다"
		  stripe 
		  style="width: 100%; cursor: pointer;">
			<el-table-column
				type="index" v-if="!isMobile"
				label="순번"
				width="80">
			</el-table-column>
			<el-table-column
			  prop="tracking_no" 
			  label="트래킹넘버"
			  width="200">
			  <template slot-scope="scope">
					{{scope.row.tracking_no}}
			  </template>
			</el-table-column>
			<el-table-column
			  v-if="!isMobile"
			  label="상태" width="100">   <!-- 오더넘버 订单号 -->
			  <template slot-scope="scope">
				<div v-if="scope.row.status == '0'" style="color:#409eff;">미认领</div>
			  	<div v-else-if="scope.row.status == '1'" style="color:#67c23a;">이미认领</div>		
			  </template>
			</el-table-column>
			<el-table-column
			  prop="remarks"
			  label="메모">
			</el-table-column>
			<el-table-column
				prop="createtime"  v-if="!isMobile"
				label="작성일"
				width="180">
			</el-table-column>
	<!-- 		<el-table-column width="80" >
				<template slot-scope="scope">
					<el-button size="mini" plain type="primary" @click="handleDetails(scope.$index, scope.row)">보기</el-button>
			
				</template>
			</el-table-column> -->
		</el-table>
		
		<div class="page">
			<el-pagination
				layout="prev, pager, next" :page-size="20"
				:total="total"  @current-change="handleCurrentChange">
			</el-pagination>
		</div>
		
		
	</div>
</template>

<script>
	import request from '@/utils/request'
	export default {
		data() {
			return {
				total:0,
				page:1,
				current_page:1,
				last_page:1,
				tableData: [],
				loading: true,
			};
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getList()
		},
		methods: {
			// clickDetails(row, column, event){
			// 	console.log(row,1)
			// 	// console.log(column,2)
			// 	// console.log(event,3)
			// 	this.$router.push(`/nodataDetails/${row.id}`)
			// },
			handleDetails(index,row){
				console.log(row,index)
				this.$router.push(`/nodataDetails/${row.id}`)
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			getList(){
				this.loading = true
				request.post('/member/Goodsnodata/getNodataList',
					{
						page:this.page,	
					}
				).then(res => {
					this.loading = false
					console.log(res,"123")
					if(res.code ==1){
						this.total = res.data.total
						this.current_page = res.data.current_page
						this.last_page = res.data.last_page
						this.tableData= res.data.data
					}	
				}).catch(() => {
					this.loading = false
				});
				
			},
			
		}
		
	}
	
</script>

<style scoped>
	.widget-location {
	    margin-top: 50px;
	    margin-bottom: 60px;
	    text-align: center;
	}
	.widget-location h3 {
	    padding: 0;
	    margin: 0;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	}
	.list-top {
	    display: flex;
	    align-items: center;
	    justify-content: space-between;
	    margin-bottom: 40px;
		padding:0 10px;
	}
	
	.page{
		padding-top: 20px;
		text-align: center;
	}
	::v-deep .el-table__header th {
		color: #333; 
		font-size: 13px;
		font-weight: bold;
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination button:disabled {
		background-color: var(--background-color);
	}
	::v-deep .el-pagination .btn-next,::v-deep .el-pagination .btn-prev {
	    background: center center no-repeat var(--background-color);
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.widget-location h3 {
		    font-size: 30px;
		    font-weight: bold;
		    margin: 0;
		    word-break: keep-all;
		}
		
		.page{
			padding-bottom: 20px;
		}
		
	}
	
</style>